import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';

import { PermittedEventLocationPipeModule } from '@main-client/src/app/pipes/permitted-event-location-pipe/permitted-event-location-pipe.module';

import { FeedItemEventMeetingMethodComponent } from './feed-item-event-meeting-method.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    PermittedEventLocationPipeModule,
    NgxLinkifyjsModule.forRoot(),
  ],
  declarations: [FeedItemEventMeetingMethodComponent],
  exports: [FeedItemEventMeetingMethodComponent],
})
export class FeedItemEventMeetingMethodModule {}
